<script setup lang="ts">
const { t } = useI18n();
const localePath = useLocalePath();
const route = useRoute();
const { metaPixelId } = useRuntimeConfig().public;
const { consent, setConsent } = useCookieConsent();

// Nothing to ask for when tracking isn't configured, or inside the embedded iframe form.
const isVisible = computed(
  () => !!metaPixelId && route.query.isIframe !== "true" && consent.value === null
);
</script>

<template>
  <ClientOnly>
    <transition name="slide-fade">
      <div
        v-if="isVisible"
        role="dialog"
        aria-live="polite"
        :aria-label="t('cookieConsent.title')"
        class="fixed inset-x-0 bottom-0 z-50 bg-white border-t border-alto-300 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]"
      >
        <div
          class="container flex flex-col gap-4 px-5 py-5 md:flex-row md:items-center md:justify-between"
        >
          <div class="text-sm leading-5 text-black md:max-w-3xl">
            <p class="mb-1 font-bold text-brand-secondary">
              {{ t("cookieConsent.title") }}
            </p>
            <p>
              {{ t("cookieConsent.text") }}
              <NuxtLinkLocale
                :to="localePath('regulations')"
                target="_blank"
                class="underline text-cerise-red-600"
              >
                {{ t("cookieConsent.policy") }}
              </NuxtLinkLocale>
            </p>
          </div>
          <div class="flex gap-3 shrink-0">
            <button
              type="button"
              class="px-[22px] py-3 text-base !leading-5 tracking-wide border rounded-3xl border-cerise-red-600 text-cerise-red-600"
              @click="setConsent('denied')"
            >
              {{ t("cookieConsent.reject") }}
            </button>
            <CoreButton class="bg-cerise-red-600" @click="setConsent('granted')">
              {{ t("cookieConsent.accept") }}
            </CoreButton>
          </div>
        </div>
      </div>
    </transition>
  </ClientOnly>
</template>
